import type UserCartStore from '../../UserData/_stores/UserCartStore'
import type { BaseItem } from '../../UserData/_stores/UserCartStore'

const BLOCKING_VALIDATION_STATUSES = ['cart', 'ordered']

function itemHasBlockingValidationFlags(item: BaseItem): boolean {
  return item.get('has_unavailable_product') ||
    item.get('has_unavailable_options') ||
    item.get('has_unavailable_branding_options') ||
    item.get('has_missing_options')
}

export function cartItemHasBlockingValidationIssue(item: BaseItem): boolean {
  return ['product', 'branding_option'].includes(item.get('type')) && itemHasBlockingValidationFlags(item)
}

export function cartCanShowBlockingItemIssues(cart: UserCartStore): boolean {
  return BLOCKING_VALIDATION_STATUSES.includes(cart.get('status'))
}

export function cartHasBlockingItemIssues(cart: UserCartStore): boolean {
  if (!cartCanShowBlockingItemIssues(cart)) {
    return false
  }

  let hasIssue = false
  const ignoredStoreCartItemIds = new Set<number>()

  cart.get('storeOrder')?.get('listItems').forEach(storeItem => {
    if (storeItem.get('ignored')) {
      const idCartItem = storeItem.get('id_cart_item')
      if (idCartItem !== null) {
        ignoredStoreCartItemIds.add(idCartItem)
      }

      return
    }

    const idCartItem = storeItem.get('id_cart_item')
    const item = idCartItem !== null
      ? cart.get('items').get(String(idCartItem))
      : undefined

    if (item === undefined || cartItemHasBlockingValidationIssue(item)) {
      hasIssue = true
      return false
    }
  })

  cart.get('items').forEach(item => {
    if (ignoredStoreCartItemIds.has(item.get('id'))) {
      return
    }

    if (cartItemHasBlockingValidationIssue(item)) {
      hasIssue = true
      return false
    }
  })

  return hasIssue
}
